import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSection from '@/views/my-projects/components/MyProjectsSection.vue';
import InvoicesTable from '@/views/my-projects/components/invoices/InvoicesTable.vue';
import { computed } from 'vue';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import { InvoiceStatus } from '@/models/Invoice';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesDraft',
  setup(__props) {

const { componentInvoicesUserAsReceiver } = useInvoice();
const { tUserFallback: t } = useUser('self');

const draftInvoices = computed(() => componentInvoicesUserAsReceiver.value.filter((invoice) => invoice.status === InvoiceStatus.Draft));


return { __sfc: true,componentInvoicesUserAsReceiver, t, draftInvoices, MyProjectsSection, InvoicesTable }
}

})